<label style="display: flex" class="form-check-label" [attr.for]="field.name" *ngIf="field">
  <ng-container
    >{{ field.name }}<span *ngIf="field.required" style="color: red">*</span>
    <div *ngIf="field.helpText" [ngbTooltip]="helpTextTooltip" triggers="click:blur" (click)="$event.stopPropagation()">
      <fa-icon style="color: black" class="ml-2 c-pointer" [icon]="faQuestionCircle"></fa-icon>
    </div>
  </ng-container>
  <ng-template #helpTextTooltip><div [innerHtml]="field.helpText" class="ql-editor"></div></ng-template>
</label>
